import React from "react"
import styled from "styled-components"
import { withi18n } from "@/helpers/hoc/withi18n"
import { withFeatureFlags } from "@/helpers/hoc/withFeatureFlags"
import compose from "recompose/compose"
import branch from "recompose/branch"
import renderNothing from "recompose/renderNothing"
import { Notification } from "@xingternal/360-components"
import { Icon } from "@xingternal/winery-ui/lib/Icon"
import { Text } from "@xingternal/winery-ui/lib/Text"
import { Flex } from "@xingternal/winery-ui/lib/Flex"

const i18n = {
  message: "360_RECRUITER_INSIGHTS_INCONSISTENT_DATA",
}

const grey = "grey600"

const Message = withi18n(i18n)(({ message }) => (
  <Flex alignItems="center" data-testid="maintenance-mode-notification">
    <Icon color={grey} name="CoreWarning" height={22} mr={2} />
    <Text color={grey} style={{ fontSize: 13 }}>
      {message}
    </Text>
  </Flex>
))

const NotificationWrapper = styled(Notification).attrs({
  showCloseIcon: false,
  type: "fail",
  level: 1,
})`
  margin: 0 12px;
`

const MaintenanceNotification = () => (
  <NotificationWrapper message={<Message />} />
)

const withMaintenanceMode = compose(
  withFeatureFlags,
  branch(
    ({ enabledFeatures }) =>
      !enabledFeatures.includes("recruiter_insights_maintenance_mode"),
    renderNothing,
  ),
)

export default withMaintenanceMode(MaintenanceNotification)
